export default __webpack_public_path__ + "static/media/rpg-desktop.a67b099f.png";